<template>
  <div class="topic-service-container">
    <!-- 头部 -->
    <header-frame></header-frame>

    <first-menu></first-menu>

    <div class="service-content">
      <h1>在线服务</h1>
      <ul class="list">
        <li @click="jump(0)">
          <div class="img"><img src="../../../static/image/service.png" alt="" /></div>
          <div class="des">
            <h3 class="service">96777服务</h3>
            <span class="text">在线服务、问题解答、实时路况</span>
          </div>
        </li>

        <li @click="jump(1)">
          <div class="img"><img src="../../../static/image/car.png" alt="" /></div>
          <div class="des">
            <h3 class="service">ETC办理</h3>
            <span class="text">使用便捷、办理优惠、低碳环保</span>
          </div>
        </li>

        <li @click="jump(2)">
          <div class="img"><img src="../../../static/image/route.png" alt="" /></div>
          <div class="des">
            <h3 class="service">在线路况</h3>
            <span class="text">第一时间、实时路况、出行省心</span>
          </div>
        </li>
      </ul>
    </div>

    <footer-frame></footer-frame>
  </div>
</template>

<script>
import codes from '@/api/codes';
import HeaderFrame from '@/components/Header';
import FooterFrame from '@/components/Footer';
import FirstMenu from '@/components/FirstMenu';
export default {
  components: {
    HeaderFrame,
    FooterFrame,
    FirstMenu,
  },
  data() {
    return {
      data: [],
    };
  },
  mounted() {
    this.getService();
  },
  methods: {
    getService() {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        menuID: codes.ONLINE_SERVICE,
      };
      this.$api.getNextLevelMenuInfo(replacement).then((res) => {
        this.data = res;
      });
    },
    jump(val) {
      window.open(this.data[val].url);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/common.scss';

.topic-service-container {
  width: calc-width(375vw);
  box-sizing: border-box;
  position: relative;

  .service-content {
    padding: calc-width(24vw) calc-width(26vw);
    box-sizing: border-box;

    h1 {
      margin: 0 0 calc-width(26vw);
      padding: 0;
      font-size: calc-width(16vw);
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      color: rgba(17, 95, 173, 1);
      box-sizing: border-box;
    }

    ul.list {
      li {
        width: calc-width(323vw);
        height: calc-width(105vw);
        padding: calc-width(31vw) calc-width(27vw);
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 13px 0px rgba(53, 54, 55, 0.07);
        margin-bottom: calc-width(19vw);
        display: flex;
        justify-content: start;
        align-items: center;

        > div.img {
          margin-right: calc-width(30vw);
          box-sizing: border-box;
        }

        > div.des {
          h3 {
            margin: 0 0 calc-width(15vw);
            padding: 0;
            font-size: calc-width(14vw);
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
          }

          span {
            font-size: calc-width(12vw);
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(147, 145, 145, 1);
            box-sizing: border-box;
          }
        }
      }
    }
  }

  /*.footer-container {*/
  /*position: absolute;*/
  /*bottom: 0;*/
  /*}*/
}
</style>



// WEBPACK FOOTER //
// src/pages/serviceonline/Serviceonline.vue